export const listCopyEs = {
    published: "Publicado",
    draft: "Borrador",
    name: "Nombre",
    role: "Rol",
    organisation: "Organización",
    email: "E-mail",
    dateOfBirth: "Fecha de nacimiento",
    labels: "Etiquetas",
    status: "Estado",
    actions: "Acciones",
};
